module.exports = __webpack_public_path__ + "static/media/start-conversion.2acc6d02.jpg";